<template>
  <success :show-promotes='false'>
    <thanks :email='email' :title='title'>
      <view-account />
    </thanks>
  </success>
</template>

<script>
import Success from '@/views/succezz/facade.vue';
import Thanks from '@/views/succezz/thanks-template';
import ViewAccount from '@/views/succezz/thanks-template/view-account.vue';
import common from '@/views/succezz/mixin/common';

export default {
  mixins: [common],
  components: {
    ViewAccount,
    Success,
    Thanks,
  },
};
</script>
